import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from './api';

// Créer une nouvelle Paiement
export const useCreatePaiement = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => api.post('/paiements/createPaiement', data),
    onSuccess: () => queryClient.invalidateQueries(['paiements']),
  });
};

// Mettre à jour une Paiement
export const useUpdatePaiement = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }) =>
      api.put(`/paiements/updatePaiement/${id}`, data),
    onSuccess: () => queryClient.invalidateQueries(['paiements']),
  });
};
// Lire toutes les paiements
export const useAllPaiements = () =>
  useQuery({
    queryKey: ['paiements'],
    queryFn: () =>
      api.get('/paiements/getAllPaiements').then((res) => res.data),
  });

// Lire toutes les paiements
export const usePagignationPaiements = (
  page = 1,
  limit = 35,
  search = '',
  boutique = null,
  reliqua = null,
  today = null,
  startDate = null,
  endDate = null,
  enrichItems = false
) =>
  useQuery({
    /**
     * AJOUT (cache pro):
     * Avant: queryKey = ['paiements', page, limit] => cache incohérent quand search/boutique change.
     * Maintenant: on inclut les filtres.
     * NB: on ne change pas le nom du hook ni l'URL API.
     *
     * AJOUT Bilans:
     * - startDate / endDate : filtre sur la date de commande (YYYY-MM-DD), les deux requis côté API.
     * - enrichItems : hydrate items[].produit pour l’affichage du tableau bilan.
     */
    queryKey: [
      'paiements',
      page,
      limit,
      search,
      boutique,
      reliqua,
      today,
      startDate,
      endDate,
      enrichItems,
    ],
    queryFn: () =>
      api
        .get('/paiements/getPagignationPaiements', {
          /**
           * AJOUT:
           * On passe search/boutique/reliqua/today au backend pour filtrer AVANT pagination.
           */
          params: {
            page,
            limit,
            search: search || undefined,
            boutique: boutique ?? undefined,
            reliqua: reliqua ? '1' : undefined,
            today: today ? '1' : undefined,
            startDate: startDate || undefined,
            endDate: endDate || undefined,
            enrichItems: enrichItems ? '1' : undefined,
          },
        })
        .then((res) => res.data),
    keepPreviousData: true,
    staleTime: 1000 * 30,
  });

// Obtenir une Paiement
export const useOnePaiement = (id) =>
  useQuery({
    queryKey: ['getOnePaiement', id],
    queryFn: () =>
      api.get(`/paiements/getOnePaiement/${id}`).then((res) => res.data),
    enabled: Boolean(id),
    staleTime: 1000 * 60 * 5, //chaque 5 minutes rafraichir les données
  });

// Obtenir un Paiement via ID de COMMANDE sélectionnée
export const useOnePaiementBySelectedCommandeID = (id) =>
  useQuery({
    queryKey: ['getOnePaiementBySelectedCommandeID', id],
    queryFn: () =>
      api
        .get(`/paiements/getPaiementBySelectedCommandeID/${id}`)
        .then((res) => res.data),
    enabled: Boolean(id),
    staleTime: 1000 * 60 * 5, //chaque 5 minutes rafraichir les données
  });

// Supprimer une Paiement
export const useDeletePaiement = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => api.delete(`/paiements/deletePaiement/${id}`),
    onSuccess: () => queryClient.invalidateQueries(['paiements']),
  });
};
